import {
  cancelExchange as cancelCommonExchange,
  CommonMessageForResponse,
  CommonMessageResponse,
  exchangeElectronMessage as exchangeCommonMessage,
} from 'electron-communication-lib/CommonForApp';
import {useEffect} from 'react';

/**
 * Used to exchange messages with the electron application. See {@link exchangeCommonMessage} for more docs.
 */
export const useCommonMessageExchange = <T extends CommonMessageForResponse>({
  message,
  responsePayloadHandler,
  dependencies = [], // for safety measure. if someone wants to run it every render cycle they can pass undefined here
}: {
  message: T;
  responsePayloadHandler: (response: CommonMessageResponse[T['type']]) => void;
  dependencies?: unknown[];
}): void => {
  useEffect(() => {
    exchangeCommonMessage(message, responsePayloadHandler);

    return () => cancelCommonExchange(message.type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
